import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/bind-3319d1f7.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Text from '../Text/Text.js';

var styles = {
  "unit-base": "4",
  "chip": "web_ui__Chip__chip",
  "round": "web_ui__Chip__round",
  "outlined": "web_ui__Chip__outlined",
  "activated": "web_ui__Chip__activated",
  "clicked": "web_ui__Chip__clicked",
  "filled": "web_ui__Chip__filled",
  "prefix": "web_ui__Chip__prefix",
  "text": "web_ui__Chip__text",
  "suffix": "web_ui__Chip__suffix"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Outlined"] = "outlined";
  Styling["Filled"] = "filled";
  return Styling;
}(Styling || {});
var Radius = /*#__PURE__*/function (Radius) {
  Radius["Round"] = "round";
  return Radius;
}(Radius || {});
var cssClasses = classNames.bind(styles);
var Chip = function Chip(_ref) {
  var _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? Styling.Outlined : _ref$styling,
    radius = _ref.radius,
    _ref$activated = _ref.activated,
    activated = _ref$activated === void 0 ? false : _ref$activated,
    _ref$clicked = _ref.clicked,
    clicked = _ref$clicked === void 0 ? false : _ref$clicked,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    onClick = _ref.onClick,
    aria = _ref.aria,
    testId = _ref.testId,
    prefix = _ref.prefix,
    text = _ref.text,
    _ref$textType = _ref.textType,
    textType = _ref$textType === void 0 ? Text.Type.Title : _ref$textType,
    suffix = _ref.suffix,
    forwardedRef = _ref.forwardedRef,
    id = _ref.id;
  var chipClass = cssClasses(styles.chip, styling, {
    round: radius === Radius.Round,
    activated: activated,
    clicked: clicked
  });
  var renderPrefix = function renderPrefix() {
    if (!prefix) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.prefix,
      "data-testid": getTestId(testId, 'prefix'),
      children: prefix
    });
  };
  var renderText = function renderText() {
    if (!text) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.text,
      children: /*#__PURE__*/jsx(Text, {
        text: text,
        type: textType,
        theme: "amplified",
        as: "span",
        truncate: true,
        testId: getTestId(testId, 'text')
      })
    });
  };
  var renderSuffix = function renderSuffix() {
    if (!suffix) return null;
    return /*#__PURE__*/jsx("div", {
      className: styles.suffix,
      "data-testid": getTestId(testId, 'suffix'),
      children: suffix
    });
  };
  return /*#__PURE__*/jsxs("button", _objectSpread(_objectSpread({
    className: chipClass
    // https://github.com/yannickcr/eslint-plugin-react/issues/1555
    // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    onClick: onClick,
    "data-testid": testId,
    ref: forwardedRef,
    "aria-pressed": activated || undefined,
    id: id
  }, aria), {}, {
    children: [renderPrefix(), renderText(), renderSuffix()]
  }));
};
var ChipWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(Chip, _objectSpread({
    forwardedRef: ref
  }, props));
});
ChipWithForwardedRef.displayName = Chip.name;
ChipWithForwardedRef.Styling = Styling;
ChipWithForwardedRef.Radius = Radius;

export { ChipWithForwardedRef, ChipWithForwardedRef as default };
//# sourceMappingURL=Chip.js.map
